export default __webpack_public_path__ + "static/media/janelle.efa6ee01.webp";